import { subDays, isBefore, isValid } from 'date-fns'

export const SYNC_WINDOW_DAYS = 7

export function isSyncedWithinDays(lastsynctime, days = SYNC_WINDOW_DAYS) {
  if (!lastsynctime) return false
  const syncDate = new Date(lastsynctime)
  if (!isValid(syncDate)) return false
  const cutoff = subDays(new Date(), days)
  return !isBefore(syncDate, cutoff)
}

export function computeSyncStats(users, days = SYNC_WINDOW_DAYS) {
  const total = users.length
  const syncedWithin = users.filter((u) => isSyncedWithinDays(u.lastsynctime, days)).length
  const notSyncedOver = total - syncedWithin
  const toPct = (n) => (total > 0 ? Math.round((n / total) * 100) : 0)

  return {
    total,
    syncedWithin,
    syncedWithinPct: toPct(syncedWithin),
    notSyncedOver,
    notSyncedOverPct: toPct(notSyncedOver),
  }
}

export function computeGroupSyncStats(total, syncedWithin) {
  const totalCount = total || 0
  const synced = syncedWithin || 0
  const toPct = (n) => (totalCount > 0 ? Math.round((n / totalCount) * 100) : 0)

  return {
    total: totalCount,
    syncedWithin: synced,
    syncedWithinPct: toPct(synced),
    notSyncedOver: totalCount - synced,
    notSyncedOverPct: toPct(totalCount - synced),
  }
}

export function getSyncHealthColor(pct) {
  if (pct >= 80) return '#43a047'
  if (pct >= 50) return '#fb8c00'
  return '#e53935'
}
